import { UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Switch,
  Upload,
} from "antd";
import { CKEditorComponent } from "../../../../components/CKEditor/CKEditor";

const { TextArea } = Input;
const { Option } = Select;

export function AddEditPostForm({
  postTypes,
  tags,
  loading,
  form,
  onSubmit,
  onCancel,
}) {
  const handleSubmit = (values) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("isActive", values.isActive || false);
    formData.append("type", values.type);

    if (values.excerpt) formData.append("excerpt", values.excerpt);
    if (values.content) formData.append("content", values.content);
    if (values.tags && values.tags.length > 0) {
      values.tags.forEach((tag) => formData.append("tags[]", tag));
    }
    if (values.image && values.image.length > 0) {
      formData.append("image", values.image[0].originFileObj);
    }
    if (values.imageUrl) {
      formData.append("imageUrl", values.imageUrl);
    }

    if (values.internalAuthor) {
      formData.append("internalAuthor", values.internalAuthor);
    }

    onSubmit(formData);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      autoComplete="off"
    >
      <Form.Item
        label="Hoạt động"
        name="isActive"
        initialValue={true}
        valuePropName="checked"
      >
        <Switch disabled={loading} size="large" />
      </Form.Item>

      <Row gutter={16}>
        <Col Col xs={24} sm={12}>
          <Form.Item
            label="Tiêu đề"
            name="title"
            rules={[
              { required: true, message: "Vui lòng nhập tiêu đề!" },
              { min: 2, max: 200, message: "Tiêu đề phải từ 2 đến 200 ký tự!" },
            ]}
          >
            <TextArea placeholder="Nhập tiêu đề" rows={2} size="large" />
          </Form.Item>
        </Col>

        <Col Col xs={24} sm={12}>
          <Form.Item
            label="Loại tin tức"
            name="type"
            rules={[{ required: true, message: "Vui lòng chọn loại tin tức!" }]}
          >
            <Select placeholder="Chọn loại tin tức" size="large">
              {postTypes.map((type) => (
                <Option key={type._id} value={type._id}>
                  {type.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col Col xs={24} sm={12}>
          <Form.Item label="Tác giả" name="internalAuthor">
            <Input placeholder="Nhập tác giả" size="large" />
          </Form.Item>
        </Col>
        <Col Col xs={24} sm={12}>
          <Form.Item label="Tags" name="tags">
            <Select
              mode="multiple"
              placeholder="Chọn tags"
              style={{ width: "100%" }}
              size="large"
            >
              {tags.map((tag) => (
                <Option key={tag._id} value={tag._id}>
                  {tag.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col Col xs={24} sm={12}>
          <Form.Item
            label="Cách chọn hình ảnh"
            name="imageType"
            initialValue="upload"
          >
            <Radio.Group size="large">
              <Radio value="upload">Upload file</Radio>
              <Radio value="url">Nhập URL</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.imageType !== currentValues.imageType
            }
          >
            {({ getFieldValue }) =>
              getFieldValue("imageType") === "upload" ? (
                <Form.Item
                  label="Hình ảnh"
                  name="image"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => e.fileList}
                >
                  <Upload
                    listType="picture"
                    maxCount={1}
                    beforeUpload={() => false}
                    accept="image/*"
                  >
                    <Button icon={<UploadOutlined />} size="large">
                      Chọn hình ảnh
                    </Button>
                  </Upload>
                </Form.Item>
              ) : (
                <Form.Item
                  label="Hình ảnh"
                  name="imageUrl"
                  rules={[
                    { required: true, message: "Vui lòng nhập URL hình ảnh!" },
                  ]}
                >
                  <Input placeholder="Nhập URL hình ảnh" size="large" />
                </Form.Item>
              )
            }
          </Form.Item>
        </Col>
      </Row>

      <Form.Item label="Nội dung" name="content">
        <CKEditorComponent placeholder="Nhập nội dung" size="large" />
      </Form.Item>

      <Form.Item>
        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            loading={loading}
            block
            onClick={onCancel}
            size="large"
          >
            Hủy
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
            size="large"
          >
            Lưu
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
